import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import ServiceAreas from '../components/ServiceAreas';
import WhyChooseUs from '../components/WhyChooseUs';
import WhatWeHandle from '../components/WhatWeHandle';
import TrustedPartners from '../components/TrustedPartners';
import FinancingTeaser from '../components/FinancingTeaser';
import FAQ from '../components/FAQ';

export default function HomePage() {

  return (
    <main id="main-content" tabIndex={-1}>
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <CTA />
      <ServiceAreas />
      <WhyChooseUs />
      <WhatWeHandle />
      <TrustedPartners />
      <FinancingTeaser />
      <FAQ />
    </main>
  );
}
